export const useElementSize = (target: HTMLElement, callback: () => any) => {
  if (process.client) {
    const resizeObserver = new ResizeObserver(callback)
    resizeObserver.observe(target)
  }
}
